import React, { useState } from 'react';
import { Box, Button, Collapse, Tooltip } from "@mui/material";
import QueuePlayNextIcon from '@mui/icons-material/QueuePlayNext';
import { DATE_FORMAT } from "commons/constants/env";
import { useSearchParams } from "react-router-dom";
import { format, isValid } from "date-fns";
import { isEmpty} from "lodash";
import reject from "lodash/reject";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "commons/store/hooks";
import { useSnackbar } from "notistack";
import { generateDataExport } from "../../../ecrf/redux/ecrfDataManagementSlice";

export interface Props<T> {
  elements?: Array<{
    render: (row: T, index: number) => React.ReactNode;
    key: string;
    hide?: boolean;
  }>;
  filters?: Array<{
    render: (row: T, index: number) => React.ReactNode;
    key: string;
    hide?: boolean;
  }>;
  buttons?: React.ReactNode[];
}

export const ActionPanel = <T extends object>(props: Props<T>) => {
  const dispatch = useAppDispatch();
  const { buttons = [] } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const [showActions, setShowActions] = useState<boolean>(false);

  const [elements, setElements] = useState<any>(Object.fromEntries(searchParams));
  const [filters, setFilters] = useState<any>(Object.fromEntries(searchParams));
  const [showFilters, setShowFilters] = useState<boolean>(searchParams?.size > 0);

  const [loading, setLoading] = useState<boolean>(false);
  const elementList = reject(props?.elements || [], (element) => !!element.hide);
  const filterElements = reject(props?.filters || [], (filter) => !!filter.hide);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleChangeElements = async (value: any, type: any) => {
    // if (isValid(value)) {
    //   elements[type] = format(value, DATE_FORMAT);
    // } else {
      elements[type] = value;
    // }

    setElements((previousState: any) => ({
      ...previousState,
      ...elements,
    }));
  };

  // const handleChangeFilters = async (value: any, type: any) => {
  //   if (isValid(value)) {
  //     filters[type] = format(value, DATE_FORMAT);
  //   } else {
  //     filters[type] = value;
  //   }
  //
  //   setFilters((previousState: any) => ({
  //     ...previousState,
  //     ...filters,
  //   }));
  // };

  const generate = async () => {
    setLoading(true);

    const elementIds: any[] = [];
    for (const element of [elements.elements]) {
      element?.value && elementIds.push(element?.value);
    }

    try {
      await dispatch(generateDataExport({ name: elements?.name, elementIds: elementIds })).unwrap();
    } catch (error: any) {
      enqueueSnackbar(error?.detail || error?.message, { variant: 'warning' });
    }

    setLoading(false);
  };

  // const filter = async () => {
  //   setLoading(true);
  //
  //   for (const [key, value] of Object.entries(filters)) {
  //     if (value === null || value === '') {
  //       searchParams.delete(key);
  //     } else {
  //       searchParams.set(key, String(value));
  //     }
  //   }
  //
  //   setSearchParams(searchParams);
  //   setLoading(false);
  // };
  //
  // const clearFilters = async () => {
  //   setFilters({});
  //   setSearchParams({});
  // };

  return (
    <>
      <Box display={'flex'} gap={'20px'} justifyContent={'end'}>
        {buttons.map((button: any, i) => (<Box key={i}>{button}</Box>))}

        <Button style={{ whiteSpace: 'nowrap', marginTop: '20px' }}
          color={'primary'}
          size={'small'}
          onClick={() => setShowActions(!showActions)}
          variant={'outlined'}>
          {showActions ? t('Hide actions') : t('Show actions')}
        </Button>

        {/*<Button style={{ whiteSpace: 'nowrap', marginTop: '20px' }}*/}
        {/*    color={'primary'}*/}
        {/*    size={'small'}*/}
        {/*    onClick={() => setShowFilters(!showFilters)}*/}
        {/*    variant={'outlined'}>*/}
        {/*  {showFilters ? t('hide-filters') : t('show-filters')}*/}
        {/*</Button>*/}
      </Box>

      <Collapse in={showActions} unmountOnExit>
        <Box display={'flex'} alignItems={'center'} mt={1} border={`1px solid #e7e7e7`} p={3} borderRadius={'10px'}>
          <Box display="grid" gridTemplateColumns={'1fr 1fr 1fr 1fr 1fr'} alignItems="center" style={{gap: "20px"}}>
            {elementList.map((element: any) =>
              <Box key={element?.key}>
                {element?.render(elements, handleChangeElements)}
              </Box>
            )}

            <Box display={'flex'} gap={'20px'} alignItems={'center'}>
              <Tooltip title={t('Generate')} arrow>
                <Button
                  variant={'outlined'}
                  onClick={(() => generate())}
                  disabled={showActions && (isEmpty(elements) || isEmpty(elements?.elements))}
                  startIcon={<QueuePlayNextIcon/>}
                  loading={loading}
                >
                   {t('Generate')}
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </Collapse>

      {/*<Collapse in={showFilters} unmountOnExit>*/}
      {/*    <Box display={'flex'} alignItems={'center'} mt={1} border={`1px solid #e7e7e7`} p={3} borderRadius={'10px'}>*/}
      {/*        <Box display="grid" gridTemplateColumns={'1fr 1fr 1fr 1fr 1fr'} alignItems="center" style={{gap: "20px"}}>*/}
      {/*            {filterElements.map((element: any) =>*/}
      {/*                <Box key={element?.key}>*/}
      {/*                    {element?.render(filters, handleChange)}*/}
      {/*                </Box>*/}
      {/*            )}*/}

      {/*            <Box display={'flex'} gap={'20px'} alignItems={'center'}>*/}
      {/*                /!*{(show && !isEmpty(filters)) &&*!/*/}
      {/*                    <>*/}
      {/*                        <Tooltip title={t('filter')} arrow>*/}
      {/*                            <StyledGlobalMedicalCentersFiltersButton*/}
      {/*                                onClick={(() => filter())}*/}
      {/*                                status={(showFilters && !isEmpty(filters))}*/}
      {/*                            >*/}
      {/*                                <FilterList/> {t('filter')}*/}
      {/*                            </StyledGlobalMedicalCentersFiltersButton>*/}
      {/*                        </Tooltip>*/}
      {/*                        <Tooltip title={t('clear-filters')} arrow>*/}
      {/*                            <StyledGlobalMedicalCentersFiltersButton*/}
      {/*                                onClick={(() => clearFilters())}*/}
      {/*                                status={(showFilters && !isEmpty(filters))}*/}
      {/*                            >*/}
      {/*                                <DeleteSweepRounded/> {t('clear')}*/}
      {/*                            </StyledGlobalMedicalCentersFiltersButton>*/}
      {/*                        </Tooltip>*/}
      {/*                    </>*/}
      {/*                /!*}*!/*/}
      {/*            </Box>*/}
      {/*        </Box>*/}
      {/*    </Box>*/}
      {/*</Collapse>*/}
    </>
  );
};
